import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDateNativeAdapter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@ngx-translate/core';

function DateRangePickerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtext(3, "From date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "input", 5, 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateRangePickerComponent_div_0_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.ngbStartDate = $event; })("click", function DateRangePickerComponent_div_0_Template_input_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r1 = ɵngcc0.ɵɵreference(6); return _r1.toggle(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DateRangePickerComponent_div_0_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r1 = ɵngcc0.ɵɵreference(6); return _r1.toggle(); });
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementStart(10, "span", 9);
    ɵngcc0.ɵɵtext(11, "today");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 10);
    ɵngcc0.ɵɵelementStart(13, "span", 11);
    ɵngcc0.ɵɵtext(14, "multiple_stop");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 2);
    ɵngcc0.ɵɵelementStart(16, "div", 12);
    ɵngcc0.ɵɵtext(17, "To date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 4);
    ɵngcc0.ɵɵelementStart(19, "input", 13, 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DateRangePickerComponent_div_0_Template_input_ngModelChange_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.ngbEndDate = $event; })("click", function DateRangePickerComponent_div_0_Template_input_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r2 = ɵngcc0.ɵɵreference(20); return _r2.toggle(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 7);
    ɵngcc0.ɵɵelementStart(22, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DateRangePickerComponent_div_0_Template_button_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r4); const _r2 = ɵngcc0.ɵɵreference(20); return _r2.toggle(); });
    ɵngcc0.ɵɵpipe(23, "translate");
    ɵngcc0.ɵɵelementStart(24, "span", 9);
    ɵngcc0.ɵɵtext(25, "event");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.ngbStartDate)("maxDate", ctx_r0.ngbEndDate);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(9, 7, "date.picker.start.date.screenreader"));
    ɵngcc0.ɵɵadvance(11);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.ngbEndDate)("maxDate", ctx_r0.today)("minDate", ctx_r0.ngbStartDate);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(23, 9, "date.picker.end.date.screenreader"));
} }
class DateRangePickerComponent {
    constructor(adapter) {
        this.adapter = adapter;
        this.startDateChange = new EventEmitter();
        this.endDateChange = new EventEmitter();
    }
    ngOnInit() {
        let currentDate = new Date(Date.now());
        this.ngbStartDate = this.adapter.fromModel(this.startDate);
        this.ngbEndDate = this.adapter.fromModel(this.endDate);
        this.today = {
            year: currentDate.getFullYear(),
            month: currentDate.getMonth() + 1,
            day: currentDate.getDate(),
        };
    }
    get ngbStartDate() {
        return this._startDate;
    }
    set ngbStartDate(value) {
        this._startDate = value;
        this.startDateChange.emit(this.adapter.toModel(value));
    }
    get ngbEndDate() {
        return this._endDate;
    }
    set ngbEndDate(value) {
        this._endDate = value;
        this.endDateChange.emit(this.adapter.toModel(value));
    }
}
DateRangePickerComponent.ɵfac = function DateRangePickerComponent_Factory(t) { return new (t || DateRangePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbDateNativeAdapter)); };
DateRangePickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DateRangePickerComponent, selectors: [["fgbcl-date-range-picker"]], inputs: { startDate: "startDate", endDate: "endDate" }, outputs: { startDateChange: "startDateChange", endDateChange: "endDateChange" }, features: [ɵngcc0.ɵɵProvidersFeature([NgbDateNativeAdapter])], decls: 1, vars: 1, consts: [["class", "date-range-picker d-flex flex-column flex-lg-row align-items-center justify-content-end", 4, "ngIf"], [1, "date-range-picker", "d-flex", "flex-column", "flex-lg-row", "align-items-center", "justify-content-end"], [1, "d-flex", "flex-column", "date-col"], [1, "from-date-text", "font-weight-bold", "text-left"], [1, "input-group", "mb-2"], ["name", "startDate", "ngbDatepicker", "", 1, "form-control", "date-field", 3, "ngModel", "maxDate", "ngModelChange", "click"], ["startDatePicker", "ngbDatepicker"], [1, "input-group-append"], ["type", "button", 1, "btn", 3, "click"], ["aria-hidden", "true", 1, "icon", "material-icons"], [1, "d-none", "d-lg-flex", "flex-column", "text-center", "mt-2", "mx-3"], ["aria-hidden", "true", 1, "icon", "material-icons", "transaction-arrow"], [1, "to-date-text", "text-left", "font-weight-bold", "mt-4", "mt-lg-0"], ["ngbDatepicker", "", "name", "endDate", 1, "form-control", "date-field", 3, "ngModel", "maxDate", "minDate", "ngModelChange", "click"], ["endDatePicker", "ngbDatepicker"]], template: function DateRangePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DateRangePickerComponent_div_0_Template, 26, 11, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.ngbStartDate && ctx.ngbEndDate);
    } }, directives: [ɵngcc2.NgIf, ɵngcc1.NgbInputDatepicker, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], pipes: [ɵngcc4.TranslatePipe], styles: [".input-group[_ngcontent-%COMP%]{margin-top:2px}"] });
DateRangePickerComponent.ctorParameters = () => [
    { type: NgbDateNativeAdapter }
];
DateRangePickerComponent.propDecorators = {
    startDate: [{ type: Input }],
    startDateChange: [{ type: Output }],
    endDate: [{ type: Input }],
    endDateChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateRangePickerComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-date-range-picker',
                template: "<div\r\n  class=\"date-range-picker d-flex flex-column flex-lg-row align-items-center justify-content-end\"\r\n  *ngIf=\"ngbStartDate && ngbEndDate\"\r\n>\r\n  <div class=\"d-flex flex-column date-col\">\r\n    <div class=\"from-date-text font-weight-bold text-left\">From date</div>\r\n    <div class=\"input-group mb-2\">\r\n      <input\r\n        class=\"form-control date-field\"\r\n        name=\"startDate\"\r\n        [(ngModel)]=\"ngbStartDate\"\r\n        ngbDatepicker\r\n        [maxDate]=\"ngbEndDate\"\r\n        #startDatePicker=\"ngbDatepicker\"\r\n        (click)=\"startDatePicker.toggle()\"\r\n      />\r\n      <div class=\"input-group-append\">\r\n        <button\r\n          class=\"btn\"\r\n          type=\"button\"\r\n          attr.aria-label=\"{{ 'date.picker.start.date.screenreader' | translate }}\"\r\n          (click)=\"startDatePicker.toggle()\"\r\n        >\r\n          <span class=\"icon material-icons\" aria-hidden=\"true\">today</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"d-none d-lg-flex flex-column text-center mt-2 mx-3\">\r\n    <span class=\"icon material-icons transaction-arrow\" aria-hidden=\"true\">multiple_stop</span>\r\n  </div>\r\n  <div class=\"d-flex flex-column date-col\">\r\n    <div class=\"to-date-text text-left font-weight-bold mt-4 mt-lg-0\">To date</div>\r\n    <div class=\"input-group mb-2\">\r\n      <input\r\n        ngbDatepicker\r\n        #endDatePicker=\"ngbDatepicker\"\r\n        class=\"form-control date-field\"\r\n        name=\"endDate\"\r\n        [(ngModel)]=\"ngbEndDate\"\r\n        [maxDate]=\"today\"\r\n        [minDate]=\"ngbStartDate\"\r\n        (click)=\"endDatePicker.toggle()\"\r\n      />\r\n\r\n      <div class=\"input-group-append\">\r\n        <button\r\n          class=\"btn\"\r\n          attr.aria-label=\"{{ 'date.picker.end.date.screenreader' | translate }}\"\r\n          type=\"button\"\r\n          (click)=\"endDatePicker.toggle()\"\r\n        >\r\n          <span class=\"icon material-icons\" aria-hidden=\"true\">event</span>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                providers: [NgbDateNativeAdapter],
                styles: [".input-group{margin-top:2px}"]
            }]
    }], function () { return [{ type: ɵngcc1.NgbDateNativeAdapter }]; }, { startDateChange: [{
            type: Output
        }], endDateChange: [{
            type: Output
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }] }); })();

class DateRangePickerModule {
}
DateRangePickerModule.ɵfac = function DateRangePickerModule_Factory(t) { return new (t || DateRangePickerModule)(); };
DateRangePickerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DateRangePickerModule });
DateRangePickerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            NgbModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DateRangePickerModule, { declarations: function () { return [DateRangePickerComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        NgbModule, ɵngcc4.TranslateModule]; }, exports: function () { return [DateRangePickerComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateRangePickerModule, [{
        type: NgModule,
        args: [{
                declarations: [DateRangePickerComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    NgbModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [DateRangePickerComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DateRangePickerComponent, DateRangePickerModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-date-range-picker.js.map